import { dataLayerPush } from 'src/helpers/gtm';

export const clickExpandButtonAnalytics = () => {
  try {
    dataLayerPush({
      event: 'professional_reviews',
    });
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Ошибка в аналитике clickExpandButtonAnalytics', error);
  }
};
